import useLanguage from "../../i18n/useLanguage";

export default function ProductImagePreview({ product }) {
  const { t } = useLanguage();
  const isTelegram = product.id === "telegram";
  return (
    <div className={`h-52 sm:h-60 overflow-hidden border-b border-white/10 ${isTelegram ? "bg-[#ffd400]" : "bg-[#edf9fb]"}`}>
      <img src={product.image} alt={t(product.imageAlt)} width={isTelegram ? 640 : 2940} height={isTelegram ? 360 : 1470} loading="lazy" decoding="async" className="h-full w-full object-contain" />
    </div>
  );
}
